<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import Component from '~/sites/oknanebodvere/pages/register'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/registrovat',
      en: '/register',
      sk: '/registrovat',
    },
  },
  mixins: [AppRouteMixin],
  methods: {
    checkRouteAccess() {
      if (this.$store.getters['user/userIsLoggedIn']) {
        this.$router.push(this.localePath({ name: 'index' }))
      }
    },
  },
}
</script>
